import clsx from 'clsx';
import styles from './MetaRow.module.css';

export function MetaRow({ label, ariaLabel, className, labelClassName, children }) {
  return (
    <div className={clsx(styles.row, className)} aria-label={ariaLabel}>
      {label != null && <span className={clsx(styles.label, labelClassName)}>{label}</span>}
      {children}
    </div>
  );
}
